import { BaseResource } from "utils/ApiUtils";

class Equipment extends BaseResource {
  constructor(args) {
    super(args, Equipment.attributes);
  }

  static columns = [
    {
      title: "Equipment Id",
      field: "equipmentId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Ihwi Id",
      field: "ihwiId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Contractor Service Id",
      field: "contractorServiceId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Equipment Type Id",
      field: "equipmentTypeId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Equipment Idle Type Id",
      field: "equipmentIdleTypeId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      type: "string",
      field: "Description_EquipmentType",
      title: "Equipment Type",
    },
    {
      type: "string",
      field: "Description_ContractorNavigation",
      title: "Contractor"
    },
    {
      type: "string",
      field: "InspectionNumber_Inspection",
      title: "Inspection #"
    },
    { type: "string", title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Quantity Used",
      field: "quantityUsed",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Hours Worked",
      field: "hoursWorked",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Hours Idle",
      field: "hoursIdle",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Comment",
      field: "comment",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Amount",
      field: "amount",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Quantity Available",
      field: "quantityAvailable",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Rate",
      field: "rate",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Reason Idle Comment",
      field: "reasonIdleComment",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Date Observed",
      field: "dateObserved",
      type: "date",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      type: "string",
      field: "Description_EquipmentIdleType",
      title: "Equipment Idle Type",
    }
  ];


  static attributes = Equipment.columns.map((r) => r.field);

  static expand = [
    { EquipmentIdleType: { select: ["Description"] } },
    { EquipmentType: { select: ["Description"] } },
    {
      ContractorService: {
        expand: {
          ContractorProject: {
            expand: {
              ContractorNavigation: {
                select: ["Description"]
              }
            }
          }
        }
      }
    },
    {
      "Ihwi": {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    },

  ];
}

export default Equipment;
